export const pad = (value: number, length = 2): string => String(value).padStart(length, '0')

export const formatNumber = (value: number, decimals = 0): string => {
    return value.toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    })
}

export const formatMultiplier = (value: number): string => {
    if (value >= 1000) return formatNumber(Math.floor(value))
    return value.toFixed(2)
}

export const formatUsd = (value: number): string => `$${formatNumber(value)}`
